import { apoiadoresContent as c } from "./content";
import cnpq from "../../../assets/png/logo/cnpq.png";
import embrapii from "../../../assets/png/logo/embrapii.png";
import igGoiano from "../../../assets/png/logo/if-goiano.png";

export function Support() {
  return (
    <section className="home-page-v2__section home-page-v2__section--apoiadores">
      <div className="home-page-v2__apoiadores-top">
        <div className="home-page-v2__section-inner home-page-v2__apoiadores-head">
          <h2 className="stacked-title">
            {c.headingLines.map((line, i) => (
              <span key={`${line}-${i}`}>{line}</span>
            ))}
          </h2>
          <p>{c.body}</p>
        </div>
      </div>
      <div className="home-page-v2__apoiadores-logos">
        <div className="home-page-v2__section-inner home-page-v2__supporters-list">
          <img
            className="home-page-v2__supporter-logo"
            src={cnpq}
            alt=""
            style={{
              height: 80
            }}
          />
          <img
            className="home-page-v2__supporter-logo"
            src={embrapii}
            alt=""
          />
          <img
            className="home-page-v2__supporter-logo"
            src={igGoiano}
            alt=""
          />
        </div>
      </div>
    </section>
  );
}
